const tipoItemPaginaList = [
    {
        id: 'TEXT', // HARDCODE.idTipoItemPaginaTextoImagem
        descricao: 'Texto / Imagem',
        ordem: 10,
    },
    {
        id: 'TEXTV', // HARDCODE.idTipoItemPaginaTextoImagemVariavel
        descricao: 'Texto / Imagem + Variáveis',
        ordem: 20,
    },
    {
        id: 'TEXTC', // HARDCODE.idTipoItemPaginaTextoImagemContasInvestimentos
        descricao: 'Texto / Imagem + Contas Investimentos',
        ordem: 30,
    },
    {
        id: 'HTML', // HARDCODE.idTipoItemPaginaHTML
        descricao: 'HTML',
        ordem: 40,
    },
    {
        id: 'HTMLV', // HARDCODE.idTipoItemPaginaHTMLVariavel
        descricao: 'HTML + Variáveis',
        ordem: 50,
    },
    {
        id: 'HTMLC', // HARDCODE.idTipoItemPaginaHTMLContasInvestimentos
        descricao: 'HTML + Contas Investimentos',
        ordem: 60,
    },
    {
        id: 'GRTB', // HARDCODE.idTipoItemPaginaGraficoTabela
        descricao: 'Gráfico / Tabela',
        ordem: 70,
    },
]

export default tipoItemPaginaList